import { render, staticRenderFns } from "./AnnouncementImage.vue?vue&type=template&id=1b737424&scoped=true"
import script from "./AnnouncementImage.vue?vue&type=script&lang=js"
export * from "./AnnouncementImage.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementImage.vue?vue&type=style&index=0&id=1b737424&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b737424",
  null
  
)

export default component.exports